import { Box } from 'braid-design-system';
import type { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  color: string;
}
export const Background = ({ color, children }: Props) => (
  <Box style={{ backgroundColor: color }}>{children}</Box>
);
